import { TableBody, TableRow } from '@mui/material';
import { useSelector } from 'react-redux';
import { getAllCalender } from './redux.selectors';
import TableCellContainer from '@libComponents/table/TableCellContainer';
import TableContainer from '@libComponents/table/TableContainer';
import TableHeaderContainer from '@libComponents/table/TableHeaderContainer';
import { ContentContainer } from '@libComponents/ContentContainer';
import { Button } from '@libComponents';
import dayjs from 'dayjs';
import { DeleteOutline } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/EditOutlined';


export default function ViewCalender({ setViewType, setData }) {
    const tableRows = useSelector((state) => getAllCalender(state));
    const TABLE_DATA = {
        'name': 'Name',
        'description': 'Description'
    };

    const handleEdit = (row) => {
        setViewType('createCalender');
        setData({ mode: 'update', row });
    }

    const handleDelete = (row) => {
        setViewType('deleteCalender');
        setData({ row });
    }

    if (!tableRows) return null;
    return (
        <ContentContainer
            title='Calender'
            sx={{ border: 0, p: "0 !important", mb: 0 }}
            AdornmentComponent={
                <Button
                    onClick={() => {
                        setViewType('createCalender');
                        setData({ mode: 'create', row:{} });
                    }}
                >
                    Add Calender
                </Button>
            }
        >

            <TableContainer sx={{ p: "0 !important" }}>
                <TableHeaderContainer>
                    {Object.values(TABLE_DATA).map((th, i) => (
                        <TableCellContainer typography='caption' key={th}>
                            {th}
                        </TableCellContainer>
                    ))}
                    <TableCellContainer typography='caption' key="action" align="right">
                        Actions
                    </TableCellContainer>
                </TableHeaderContainer>
                <TableBody>
                    {tableRows.map((row, i) => (
                        <TableRow key={i}>
                            {Object.keys(TABLE_DATA).map((key, index) => {
                                let columnData = row[key];
                                switch (key) {
                                    case 'startTime':
                                        return (
                                            <TableCellContainer key={key}>
                                                {dayjs(columnData).format("HH:mm")}
                                            </TableCellContainer>
                                        )
                                    case 'endTime':
                                        return (
                                            <TableCellContainer key={key}>
                                                {dayjs(columnData).format("HH:mm")}
                                            </TableCellContainer>
                                        )
                                    default:
                                        return (
                                            <TableCellContainer key={key}>
                                                {columnData}
                                            </TableCellContainer>
                                        )
                                }
                            })}
                            <TableCellContainer
                                align='right'
                                sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end' }}
                            >
                                <EditIcon
                                    onClick={() => { handleEdit(row) }}
                                    sx={{ cursor: 'pointer', opacity: 0.75 }}
                                />

                                <DeleteOutline
                                    sx={{ cursor: 'pointer', opacity: 0.5 }}
                                    onClick={() => { handleDelete(row) }}
                                />
                            </TableCellContainer>
                        </TableRow>
                    ))}
                </TableBody>

            </TableContainer>
        </ContentContainer>
    );
}
